<template>
	<div><h1>Relatórios</h1></div>
</template>

<script>
export default {}
</script>

<style></style>
